import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_OB_CODES_REQUEST: '',
  GET_OB_CODES_SUCCESS: '',
  GET_OB_CODES_FAILURE: '',

};

types = setStoreTypeValues(types, 'authOBCodes');

export default types;
